import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';

import './Login.scss';

import commonConstant from '../../common/_commonConstant';
import { addClassBGBlack, removeClassBGBlack, getCookieToken } from '../../common/_commonFunction';
import { TemplateCenter, Loading } from '../../components';
import { InputWithIcon, history, isAndroid } from '../../helpers';
import { fetchLogin } from '../../actions';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'username': '',
      'password': '',
      'loading': false,
      'warningUsername': false,
      'warningTextUsername': null,
      'warningPassword': false,
      'warningTextPassword': null,
    };
    if (getCookieToken()) {
      history.push(commonConstant.pathCheckRedirect);
    }
  }

  componentDidMount() {
    if (!(isAndroid() && window.screen.width === 360 && window.screen.height === 720)) {
      addClassBGBlack();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { login } = this.props;

    if (nextProps.login && nextProps.login !== login) {
      if (nextProps.login.status === 200) {
        return history.push(commonConstant.pathCheckRedirect);
      } else if (nextProps.login.status === 400) {
        return this.setState({
          'username': '',
          'password': '',
          'loading': false,
          'warningUsername': true,
          'warningTextUsername': null,
          'warningPassword': true,
          'warningTextPassword': 'username / password ไม่ถูกต้อง',
        });
      }
    }
  }

  componentWillUnmount() {
    removeClassBGBlack();
  }

  handleChange = (key, event) => this.setState({ [key]: event.target.value });

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.handleLogin();
    }
  }

  handleLogin = () => {
    const { username, password } = this.state;

    if (!username && !password) {
      return this.setState({
        'warningUsername': true,
        'warningTextUsername': 'กรุณากรอก username',
        'warningPassword': true,
        'warningTextPassword': 'กรุณากรอกรหัสผ่าน',
      });
    } else if (!username) {
      return this.setState({
        'warningUsername': true,
        'warningTextUsername': 'กรุณากรอก username',
        'warningPassword': false,
        'warningTextPassword': null,
      });
    } else if (!password) {
      return this.setState({
        'warningUsername': false,
        'warningTextUsername': null,
        'warningPassword': true,
        'warningTextPassword': 'กรุณากรอกรหัสผ่าน',
      });
    }

    this.setState({
      'loading': true,
      'warningUsername': false,
      'warningTextUsername': null,
      'warningPassword': false,
      'warningTextPassword': null,
    });
    return this.props.dispatch(fetchLogin({ 'username': username, password }));
  }

  handleUILogin = () => {
    const { username, password, warningUsername, warningTextUsername, warningPassword, warningTextPassword } = this.state;

    return (
      <>
        <div className="box-input">
          <InputWithIcon
            id="username"
            value={username}
            icon="fas fa-user"
            placeholder="username"
            onChange={event => this.handleChange('username', event)}
            warning={warningUsername}
            warningText={warningTextUsername}
          />
          <InputWithIcon
            id="password"
            value={password}
            icon="fas fa-lock"
            placeholder="password"
            type="password"
            onChange={event => this.handleChange('password', event)}
            onKeyPress={this.handleKeyPress}
            warning={warningPassword}
            warningText={warningTextPassword}
          />
        </div>
        <div className="box-btn">
          <Button className="btn-primary btn-login" id="btn-login" onClick={this.handleLogin}>
            ลงชื่อเข้าใช้
          </Button>
          {/* TODO: check req after sprint to redirect forgot password page  */}
          <Link className="link btn-forgot-password" id="btn-forgot-password" to={commonConstant.pathContactUs}>
            ลืมรหัสผ่าน?
          </Link>
        </div>
      </>
    );
  }

  render() {
    const { loading } = this.state;

    return (
      <div
        className={`Login${(isAndroid() && window.screen.width === 360 && window.screen.height === 720) ? ' x2' : ''}`}>
        {loading ? <Loading/> : null}
        <TemplateCenter>
          {this.handleUILogin()}
        </TemplateCenter>
      </div>
    );
  }
}

Login.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'login': PropTypes.shape({
    'status': PropTypes.any,
  }),
};

const mapStateToProps = ({ login }) => ({ login });

export default connect(mapStateToProps)(Login);
